export default function(attributesArray) {
	const userObject = {};
	for (let i = 0; i < attributesArray.length; i++) {
		userObject[attributesArray[i].getName()] = attributesArray[i].getValue();
	}

	let identities = [];
	if (userObject.identities) {
		try {
			const identitiesArray = JSON.parse(userObject.identities);
			identities = identitiesArray.map(identity => identity.providerType);
		} catch (e) {
		}
	}

	return {
		family_name: userObject.family_name,
		given_name: userObject.given_name,
		// "onboardingcomplete" is used only for user redirect back to the drupal site(value from CRM is used on the application pages);
		onboardingcomplete: userObject['custom:onboarding_status'],
		username: userObject.sub,
		identities
	}
}
